require('../../modules/es.typed-array.reverse');
